import dayjs from 'dayjs'
import html2pdf from 'html2pdf.js'

const formatDate = (date) => {
  if (!date) return '____년 __월 __일'
  try {
    return dayjs(date).format('YYYY년 MM월 DD일')
  } catch {
    return '____년 __월 __일'
  }
}

const formatBirthDate = (date) => {
  if (!date) return '____년 __월 __일'
  try {
    return dayjs(date).format('YYYY년 MM월 DD일')
  } catch {
    return '____년 __월 __일'
  }
}

const getCompanyInfo = (data) => ({
  companyName: data?.companyName || 'HOW TO YAK',
  companyNameDisplay: data?.companyNameDisplay || '주식회사 하우투약',
  companyAddress:
    data?.companyAddress || '서울시 강남구 삼성동 157-38, 브이플렉스 5층',
  representativeName: data?.representativeName || '김경열',
})

// 재직증명서 템플릿
const buildEmploymentCertificateHtml = (data) => {
  const {
    companyName,
    companyNameDisplay,
    companyAddress,
    representativeName,
  } = getCompanyInfo(data)

  const issueNumber = data?.certificateNo || '____'
  const issueDate = formatDate(data?.issueDate || new Date())
  const employeeName = data?.employeeName || data?.name || '____'
  const birthDate = formatBirthDate(data?.birthDate || data?.birthday)
  const address = data?.address || '____'
  const employmentStartDate = formatDate(
    data?.employmentStartDate || data?.joinDate,
  )
  const jobGroup = data?.jobGroup || data?.position || '____'
  const department = data?.department || data?.teamName || '____'
  const purpose = data?.purpose || '____'
  const employeeType = data?.employeeType || data?.rank || data?.title || '사원'

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          body {
            margin: 0;
            padding: 0;
            font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
            color: #191a1c;
            line-height: 1.4;
            width: 210mm;
            height: auto;
            min-height: auto;
            max-height: 297mm;
            background: white;
            overflow: visible;
            page-break-inside: avoid !important;
            page-break-after: avoid !important;
            page-break-before: avoid !important;
          }
          @page {
            size: A4;
            margin: 0;
          }
          div, table, tr, td, p {
            page-break-inside: avoid !important;
          }
        </style>
      </head>
      <body style="letter-spacing: -0.03em; margin: 0; padding: 0; height: auto; max-height: 297mm; overflow: visible;">
        <div style="width: 210mm; height: auto; max-height: 297mm; background: white; box-sizing: border-box; display: block; position: relative; margin: 0; padding: 0; overflow: visible; page-break-inside: avoid !important;">

          <!-- 메인 컨텐츠 -->
          <div style="padding: 20mm 25mm; letter-spacing: -0.03em; page-break-inside: avoid;">

            <!-- 제목 및 발급번호 -->
            <div style="position: relative; margin-bottom: 25px; page-break-inside: avoid;">
              <div style="font-size: 24px; font-weight: 700; text-align: left; letter-spacing: -0.6px;">재직증명서</div>
              <div style="position: absolute; right: 0; top: 50%; transform: translateY(-100%); font-size: 13px; color: #000; letter-spacing: -0.335px; font-weight: 400;">발급 번호: ${issueNumber}</div>
            </div>

            <!-- 직원 정보 테이블 -->
            <div style="margin-bottom: 20px; page-break-inside: avoid;">
              <table style="width: 100%; border-collapse: collapse; font-size: 13px; border-radius: 8px; overflow: hidden;">
                <!-- 성명, 생년월일 및 주소 -->
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">성명</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${employeeName}</td>
                </tr>
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">생년월일</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${birthDate}</td>
                </tr>
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">주소</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${address}</td>
                </tr>

                <!-- 간격용 빈 행 -->
                <tr>
                  <td colspan="2" style="height: 24px; padding: 0; border: none; background: transparent;"></td>
                </tr>

                <!-- 현재 직원 유형, 재직 기간 -->
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">현재 직원 유형</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${employeeType}</td>
                </tr>
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">재직기간</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${employmentStartDate} ~ 현재</td>
                </tr>

                <!-- 간격용 빈 행 -->
                <tr>
                  <td colspan="2" style="height: 24px; padding: 0; border: none; background: transparent;"></td>
                </tr>

                <!-- 직군, 부서 -->
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">직군</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${jobGroup}</td>
                </tr>
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">부서</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${department}</td>
                </tr>

                <!-- 간격용 빈 행 -->
                <tr>
                  <td colspan="2" style="height: 24px; padding: 0; border: none; background: transparent;"></td>
                </tr>

                <!-- 용도 -->
                <tr>
                  <td style="width: 30%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">용도</td>
                  <td style="width: 70%; padding: 8px 0 12px 0; font-weight: 400; color: #000; vertical-align: top; font-size: 13px; letter-spacing: -0.335px;">${purpose}</td>
                </tr>
              </table>
            </div>

            <!-- 확인 문구 -->
            <div style="text-align: right; margin-bottom: 15px; page-break-inside: avoid; font-size: 13px; font-weight: 400; letter-spacing: -0.335px;">
              <p style="font-size: 13px; font-weight: 400; letter-spacing: -0.03em; color: #000; margin-bottom: 12px;">위와 같이 근무 중 임을 확인합니다.</p>
            </div>

            <!-- 회사 정보 및 서명 -->
            <div style="margin-top: 30px; padding-top: 30px; page-break-inside: avoid;">

              <!-- 첫 번째 row: 로고/회사명 | 사업주 정보 -->
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 25px;">
                <!-- 로고 및 회사명 -->
                <div style="display: flex; align-items: center; gap: 12px; overflow: visible;">
                  <img src="/assets/icon/aops/howtoyak-logo.png" style="height: 50px; width: auto; object-fit: contain; display: block;" />
                  <span style="font-size: 30px; font-weight: 600; color: #191a1c; letter-spacing: -1.05px;">${companyName}</span>
                </div>

                <!-- 회사 정보 -->
                <div style="font-size: 13px; color: #000; line-height: 2;">
                  <p style="font-size: 13px; color: #000; font-weight: 400; letter-spacing: -0.335px; margin-bottom: 8px;">${issueDate}</p>
                  <p style="margin: 0 0 8px 0; font-weight: 400; letter-spacing: -0.335px; font-size: 13px; color: #000">${companyNameDisplay}</p>
                  <p style="margin: 0 0 8px 0; font-weight: 400; letter-spacing: -0.03em; font-size: 13px; color: #000">${companyAddress}</p>

                  <div style="margin-top: 30px; position: relative;">                 
                    <div style="display: flex; align-items: center;">
                      <p style="margin: 0 8px 0 0; font-weight: 400; letter-spacing: -0.03em; font-size: 13px; color: #000; z-index: 1;">
                        대표이사 <p>${representativeName}</p>
                      </p>
                      <img src="/assets/seal.png" style="width: 90px; height: 90px; display: block; flex-shrink: 0; margin-left: -8px; z-index: 0;" />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </body>
    </html>
  `
}

// 공통 PDF 생성 로직
const createPdfFromHtml = async (htmlContent) => {
  const iframe = document.createElement('iframe')
  iframe.style.position = 'absolute'
  iframe.style.left = '-9999px'
  iframe.style.width = '210mm'
  iframe.style.height = 'auto'
  iframe.style.border = 'none'
  document.body.appendChild(iframe)

  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
  iframeDoc.open()
  iframeDoc.write(htmlContent)
  iframeDoc.close()

  await new Promise((resolve) => setTimeout(resolve, 1500))

  const body = iframeDoc.body

  let checkCount = 0
  await new Promise((resolve) => {
    const checkRender = () => {
      checkCount++
      const hasContent = body.textContent && body.textContent.trim().length > 0
      const hasHeight = body.offsetHeight > 0

      if (hasContent && hasHeight) {
        setTimeout(resolve, 500)
      } else if (checkCount > 100) {
        resolve()
      } else {
        setTimeout(checkRender, 50)
      }
    }
    checkRender()
  })

  // 실제 콘텐츠 높이 확인 및 iframe 높이 조정
  const actualHeight = body.scrollHeight || body.offsetHeight
  const contentHeight = Math.min(actualHeight, 297 * 3.779527559)
  iframe.style.height = `${contentHeight / 3.779527559}mm`

  const options = {
    margin: [0, 0, 0, 0],
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      letterRendering: true,
      logging: false,
      allowTaint: true,
      windowWidth: 210 * 3.779527559,
      height: contentHeight,
      width: 210 * 3.779527559,
      scrollX: 0,
      scrollY: 0,
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait',
      compress: true,
    },
    pagebreak: {
      mode: ['avoid-all', 'css', 'legacy'],
      avoid: ['tr', 'td', 'div', 'p', 'table', 'body'],
      before: '.page-break-before',
      after: '.page-break-after',
    },
  }

  const pdfBlob = await html2pdf().set(options).from(body).outputPdf('blob')

  document.body.removeChild(iframe)

  return pdfBlob
}

/**
 * 재직증명서 PDF 생성
 * @param {Object} data - 재직증명서 데이터
 * @returns {Promise<Blob>} PDF Blob
 */
export const generateEmploymentCertificatePdf = async (data) => {
  const htmlContent = buildEmploymentCertificateHtml(data)

  try {
    return await createPdfFromHtml(htmlContent)
  } catch (error) {
    console.error('재직증명서 PDF 생성 오류:', error)
    throw error
  }
}
